module.exports = __webpack_public_path__ + "img/WSM.df7b3aa4.gif";